module.exports = __webpack_public_path__ + "static/img/1.d2090e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/1.png
// module id = 3uw8
// module chunks = 0